import { ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';
import SideModalHeader, { ISideModalHeaderProps } from './SideModalHeader';
import CloseButton from '../CloseButton';
import { SidebarSizeType } from './types';
import { useClickOutside } from '~/hooks/events';
import * as Styles from './styles';

interface ISideModalProps {
  size: SidebarSizeType;
  isOpen: boolean;
  onClose(): void;
  children: ReactNode;
  heading: ISideModalHeaderProps;
}

const SideModal = ({ size, isOpen, onClose, children, heading }: ISideModalProps) => {
  const wrapperRef = useClickOutside<HTMLDivElement>(onClose);

  return (
    <CSSTransition
      in={isOpen}
      classNames="website-side-menu-transition"
      timeout={{ enter: 200, exit: 150 }}
      unmountOnExit
    >
      <Styles.Wrapper role="presentation">
        <Styles.List className="website-sidebar-list" ref={wrapperRef} size={size}>
          <Styles.HeaderWrapper className="spread">
            <SideModalHeader {...heading} />
            <CloseButton onClose={onClose} />
          </Styles.HeaderWrapper>

          <div className="has-y-scroll full-flex">{children}</div>
        </Styles.List>
      </Styles.Wrapper>
    </CSSTransition>
  );
};

export default SideModal;
